import { Fragment, PropsWithChildren, useCallback, useRef } from 'react';

import {
  FetchNextPageOptions,
  InfiniteData,
  InfiniteQueryObserverResult,
} from '@tanstack/react-query';

import { Skeleton } from '@/components/ui/skeleton';
import useIntersectionObserver from '@/hooks/useIntersectionObserver';

interface Props<T = unknown> {
  fetchNextPage: (
    options?: FetchNextPageOptions
  ) => Promise<InfiniteQueryObserverResult<InfiniteData<T, unknown>, Error>>;
  hasNextPage: boolean;
  skeleton?: React.ReactNode;
}

const defaultSkeleton = <Skeleton className="h-10 w-full" />;

export const TableInfiniteLoader = ({
  children,
  fetchNextPage,
  hasNextPage,
  skeleton = defaultSkeleton,
}: PropsWithChildren<Props>) => {
  const loadMoreRef = useRef<HTMLDivElement>(null);

  const handleNextPageFetch = useCallback(() => {
    return fetchNextPage();
  }, [fetchNextPage]);

  useIntersectionObserver({ target: loadMoreRef, onIntersect: handleNextPageFetch });

  return (
    <>
      {children}
      {hasNextPage && <div ref={loadMoreRef}>{skeleton}</div>}
    </>
  );
};
